// @flow
import React, { useCallback } from "react";
import Modal from "components/Modal";
import Upload from "views/upload";
import CloseButton from "components/ModalCloseButton";
import { createModal } from "react-modal-promise";
import { usePostMessageHandler } from "hooks";
import { ModalAction } from "hooks/PostMessage/Actions";
import uppy from "data/uppy";

type Props = {
    /** whether to show modal */
    open: boolean,
    /** target folder itemUri */
    itemUri: string,
    /** callback when user closes Modal */
    close: () => void,
};

/**
 * UploadModal
 */
const UploadModal = ({ open, itemUri, close }: Props) => {
    const handleCancel = useCallback(() => {
        //#59285 Remove file from queue on Cancel
        uppy.reset();
        close();
    }, [close]);
    usePostMessageHandler({
        [ModalAction.Close]: handleCancel,
        [ModalAction.CloseLegacy]: handleCancel,
    });
    return (
        <Modal
            fullscreen
            enforceFocus={false}
            show={open !== false}
            onHide={handleCancel}
            style={{ zIndex: 1050 }} /* correctly overlays map modal */
            headerSize={0}
            footerSize={0}
        >
            <Modal.Body>
                <Upload
                    asModal={true}
                    onClose={handleCancel}
                    itemUri={itemUri}
                    topRowEnd={<CloseButton onClick={handleCancel} />}
                />
            </Modal.Body>
        </Modal>
    );
};

export default UploadModal;
export const openUploadModal = createModal(UploadModal);
